export const claveRondaLocal = (username, idGenerado) =>
  `ronda-offline:${String(username || '').trim()}:${String(idGenerado || '').trim()}`;

export const leerRondaLocal = (username, idGenerado) => {
  try {
    const raw = localStorage.getItem(claveRondaLocal(username, idGenerado));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !Array.isArray(data.marcas)) return null;
    return {
      ...data,
      registros: Array.isArray(data.registros) ? data.registros : []
    };
  } catch {
    return null;
  }
};

export const guardarRondaLocal = (username, idGenerado, data) => {
  localStorage.setItem(claveRondaLocal(username, idGenerado), JSON.stringify(data));
};

export const borrarRondaLocal = (username, idGenerado) => {
  localStorage.removeItem(claveRondaLocal(username, idGenerado));
};

export const tieneRondaLocal = (username, idGenerado) =>
  Boolean(leerRondaLocal(username, idGenerado));
